/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LicenseType } from '../../models/license-type';

export interface ApiMasterLicenseTypeGetActiveGet$Params {
}

export function apiMasterLicenseTypeGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterLicenseTypeGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LicenseType>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterLicenseTypeGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LicenseType>>;
    })
  );
}

apiMasterLicenseTypeGetActiveGet.PATH = '/api/Master/LicenseType/GetActive';
